import { Component, ViewChild, ElementRef } from '@angular/core';
import {NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lp2-mobile-grammar-guide',
  templateUrl: './mobile-grammar-guide.component.html',
  styleUrls: ['./mobile-grammar-guide.component.scss']
})
export class MobileGrammarGuideComponent {
  @ViewChild('content') content: ElementRef;
  modal: NgbModalRef;

  constructor(private modalService: NgbModal) {}

  open() {
    const modalOptions: NgbModalOptions = {
      size: 'lg',
      windowClass: 'full-modal m-grammar-guide',
    };
    this.modal =  this.modalService.open(this.content, modalOptions);
  }

  close() {
    if (!this.modal) { return; }
    this.modal.close();
  }

}



// WEBPACK FOOTER //
// ./ts/app/shared/mobile-grammar-guide/mobile-grammar-guide.component.ts